// analytics.js
import { logEvent } from "firebase/analytics";
import { app_analytics } from "./config";

const Analytics = {
  // 2️⃣ List Views
  trackListView: async (listName, userType) => {
    console.log("trackListView", listName, userType);
    await logEvent(app_analytics, "list_view", {
      list_name: listName,
      user_type: userType,
    });
    console.log("trackListView completed");
  },

  // 3️⃣ Register Flow
  trackRegister: async (email, userType) => {
    console.log("trackRegister", email, userType);
    await logEvent(app_analytics, "register", {
      email: email,
      user_type: userType,
    });
    console.log("trackRegister completed");
  },

  // 3️⃣ Login Flow
  trackLogin: async (email, userType) => {
    console.log("trackLogin", email, userType);
    await logEvent(app_analytics, "login", {
      email: email,
      user_type: userType,
    });
    console.log("trackLogin completed");
  },

  trackOtpVerified: async (userType) => {
    console.log("trackOtpVerified", userType);
    await logEvent(app_analytics, "otp_verified", { user_type: userType });
    console.log("trackOtpVerified completed");
  },

  trackUpgrade: async (userType) => {
    console.log("trackUpgrade", userType);
    await logEvent(app_analytics, "upgrade_profile", { user_type: userType });
    console.log("trackUpgrade completed");
  },

  trackUpdateProfile: async (userType, profileType) => {
    console.log("trackUpdateProfile", userType, profileType);
    await logEvent(app_analytics, "update_profile", {
      user_type: userType,
      profile_type: profileType,
    });
    console.log("trackupdateProfile completed");
  },

  // 7️⃣ Engagement
  trackLogout: async (userType) => {
    console.log("trackLogout", userType);
    await logEvent(app_analytics, "logout", { user_type: userType });
    console.log("trackLogout completed");
  },
};

export default Analytics;
